// extracted by mini-css-extract-plugin
module.exports = {"container":"textAlignmentPicker_container__dPTDo"};